(() => {
  const ORIGINAL_LABEL_ATTR = 'data-bloom-original-filter-label';
  const BOTTLE_MEMBER_ATTR = 'data-bloom-bottle-member';
  const BOTTLE_MASTER_ATTR = 'data-bloom-bottle-master';
  const SYNTHETIC_30_ATTR = 'data-bloom-synthetic-30ml';
  const THIRTY_MEMBER_ATTR = 'data-bloom-30ml-member';
  const THIRTY_MASTER_ATTR = 'data-bloom-30ml-master';
  let rebuildQueued = false;

  const cleanLabel = (text) => (text || '').replace(/\s*\(\s*\d+\s*\)\s*$/, '').trim();
  const normalise = (text) => cleanLabel(text).toLowerCase().replace(/\s+/g, ' ').trim();

  const getRawLabel = (li) => {
    if (li.hasAttribute(ORIGINAL_LABEL_ATTR)) return li.getAttribute(ORIGINAL_LABEL_ATTR) || '';
    const raw = cleanLabel(li.querySelector('label')?.textContent || '');
    li.setAttribute(ORIGINAL_LABEL_ATTR, raw);
    return raw;
  };

  const classify = (label) => {
    const lower = normalise(label);
    if (!lower) return null;
    if (lower.includes('body lotion')) return { type: 'hide' };

    if (
      lower.includes('bottle') &&
      (lower.includes('original') || lower.includes('tester') || lower.includes('unboxed') || lower.includes('full size') || lower.includes('full-size'))
    ) {
      return { type: 'bottle', key: 'original-bottle', label: 'Original Bottle', order: 100000 };
    }

    const match = lower.match(/^(\d+(?:\.\d+)?)\s*ml\b/);
    if (!match) return null;

    const size = Number(match[1]);
    if (!Number.isFinite(size)) return null;

    return {
      type: 'size',
      key: `size-${size}`,
      label: `${Number.isInteger(size) ? size : String(size)}ml`,
      order: size,
    };
  };

  const isSizeDetails = (details) => {
    const index = (details.dataset.index || '').toLowerCase();
    const summary = (details.querySelector('summary')?.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();
    return index.includes('option.size') || summary === 'size' || summary.startsWith('size ');
  };

  const getSizeDetails = () => Array.from(document.querySelectorAll('details[data-filter]')).filter(isSizeDetails);

  const readCount = (li) => {
    const match = (li.querySelector('label')?.textContent || '').match(/\(\s*(\d+)\s*\)\s*$/);
    return match ? Number(match[1]) : null;
  };

  const setLabel = (li, text, count = null) => {
    const label = li.querySelector('label');
    if (!label) return;

    const countSpan = Array.from(label.querySelectorAll('span')).find((span) => /\(\s*\d+\s*\)/.test(span.textContent || ''));
    const textNodes = Array.from(label.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());

    if (textNodes.length) {
      textNodes[0].textContent = text;
      textNodes.slice(1).forEach((node) => { node.textContent = ''; });
    } else {
      label.insertBefore(document.createTextNode(text), label.firstChild);
    }

    if (countSpan) {
      if (Number.isFinite(count)) {
        countSpan.textContent = `(${count})`;
        countSpan.hidden = false;
      } else {
        countSpan.textContent = '';
        countSpan.hidden = true;
      }
    }
  };

  const chooseSizeMember = (members) => {
    const active = members.find(({ input }) => input.checked);
    if (active) return active;

    const availableDecant = members.find(({ input, rawLabel, count }) =>
      /\bdecant\b/i.test(rawLabel) && !input.disabled && (count === null || count > 0)
    );
    if (availableDecant) return availableDecant;

    const decant = members.find(({ input, rawLabel }) => /\bdecant\b/i.test(rawLabel) && !input.disabled);
    if (decant) return decant;

    const enabled = members.find(({ input }) => !input.disabled);
    return enabled || members[0] || null;
  };

  const chooseBottleMaster = (members) => {
    const active = members.find(({ input }) => input.checked);
    if (active) return active;
    const enabled = members.find(({ input, count }) => !input.disabled && (count === null || count > 0));
    return enabled || members.find(({ input }) => !input.disabled) || members[0] || null;
  };

  const ensure30mlGroup = (details, list, groups, items) => {
    const existingGroup = groups.get('size-30');
    const existingValues = new Set((existingGroup?.members || []).map(({ rawLabel }) => normalise(rawLabel)));
    const aliases = ['30ml decant', '30ml'];
    const missingAliases = aliases.filter((value) => !existingValues.has(normalise(value)));

    if (!missingAliases.length) return existingGroup;

    const source =
      existingGroup?.members?.find(({ input }) => !input.disabled)?.li ||
      existingGroup?.members?.[0]?.li ||
      items.find((li) => {
        const input = li.querySelector('input[type="checkbox"][name]');
        return input && !input.disabled && classify(getRawLabel(li))?.type === 'size';
      }) ||
      items.find((li) => {
        const input = li.querySelector('input[type="checkbox"][name]');
        return input && classify(getRawLabel(li))?.type === 'size';
      });

    const sourceInput = source?.querySelector('input[type="checkbox"][name]');
    if (!source || !sourceInput?.name) return existingGroup;

    const paramName = sourceInput.name;
    const activeValues = new URLSearchParams(window.location.search)
      .getAll(paramName)
      .map((value) => normalise(value));

    let group = existingGroup;
    const createdSyntheticGroup = !group;
    if (!group) {
      group = {
        type: 'size',
        key: 'size-30',
        label: '30ml',
        order: 30,
        members: [],
        createdSyntheticGroup: true,
      };
      groups.set('size-30', group);
    }

    missingAliases.forEach((value, aliasIndex) => {
      const li = source.cloneNode(true);
      const input = li.querySelector('input[type="checkbox"]');
      const label = li.querySelector('label');
      if (!input || !label) return;

      const id = `BloomSynthetic30-${(details.dataset.index || 'size').replace(/[^a-zA-Z0-9_-]/g, '-')}-${aliasIndex}`;

      li.setAttribute(SYNTHETIC_30_ATTR, 'true');
      li.setAttribute(ORIGINAL_LABEL_ATTR, value);
      li.removeAttribute(BOTTLE_MEMBER_ATTR);
      li.removeAttribute(BOTTLE_MASTER_ATTR);
      li.removeAttribute(THIRTY_MASTER_ATTR);
      li.hidden = true;

      input.name = paramName;
      input.value = value;
      input.id = id;
      input.checked = activeValues.includes(normalise(value));
      input.disabled = false;
      input.removeAttribute(BOTTLE_MEMBER_ATTR);
      input.removeAttribute(BOTTLE_MASTER_ATTR);
      input.removeAttribute(THIRTY_MASTER_ATTR);

      label.setAttribute('for', id);
      setLabel(li, value, null);
      list.appendChild(li);

      group.members.push({ li, input, rawLabel: value, count: null, synthetic: true });
    });

    if (createdSyntheticGroup) group.createdSyntheticGroup = true;
    group.hasSynthetic = true;
    return group;
  };

  const rebuildDetails = (details) => {
    const list = details.querySelector('.details__content ul.list');
    if (!list) return;

    list.querySelectorAll(`li[${SYNTHETIC_30_ATTR}]`).forEach((li) => li.remove());

    const groups = new Map();
    const items = Array.from(list.children).filter((li) => li.tagName === 'LI');

    items.forEach((li) => {
      li.hidden = false;
      li.removeAttribute(BOTTLE_MEMBER_ATTR);
      li.removeAttribute(BOTTLE_MASTER_ATTR);
      li.removeAttribute(THIRTY_MEMBER_ATTR);
      li.removeAttribute(THIRTY_MASTER_ATTR);

      const input = li.querySelector('input[type="checkbox"][name]');
      if (!input) return;
      input.removeAttribute(BOTTLE_MEMBER_ATTR);
      input.removeAttribute(BOTTLE_MASTER_ATTR);
      input.removeAttribute(THIRTY_MEMBER_ATTR);
      input.removeAttribute(THIRTY_MASTER_ATTR);

      const rawLabel = getRawLabel(li);
      const meta = classify(rawLabel);
      if (!meta) return;

      if (meta.type === 'hide') {
        li.hidden = true;
        return;
      }

      if (!groups.has(meta.key)) groups.set(meta.key, { ...meta, members: [] });
      groups.get(meta.key).members.push({ li, input, rawLabel, count: readCount(li) });
    });

    ensure30mlGroup(details, list, groups, items);

    Array.from(groups.values())
      .filter((group) => group.type === 'size')
      .sort((a, b) => a.order - b.order)
      .forEach((group) => {
        const chosen = chooseSizeMember(group.members);
        group.chosen = chosen || null;

        group.members.forEach(({ li, input }) => {
          li.hidden = true;
          if (group.key === 'size-30') {
            li.setAttribute(THIRTY_MEMBER_ATTR, 'true');
            input.setAttribute(THIRTY_MEMBER_ATTR, 'true');
          }
        });
        if (!chosen) return;

        chosen.li.hidden = false;

        if (group.key === 'size-30') {
          const anyChecked = group.members.some(({ input }) => input.checked);
          const anyEnabled = group.members.some(({ input }) => !input.disabled);
          chosen.li.setAttribute(THIRTY_MASTER_ATTR, 'true');
          chosen.input.setAttribute(THIRTY_MASTER_ATTR, 'true');
          chosen.input.checked = anyChecked;
          chosen.input.disabled = !anyChecked && !anyEnabled;
          setLabel(chosen.li, '30ml', group.hasSynthetic ? null : chosen.count);
        } else {
          setLabel(chosen.li, group.label, chosen.count);
        }
      });

    const thirtyGroup = groups.get('size-30');
    if (thirtyGroup?.createdSyntheticGroup && thirtyGroup.chosen) {
      const nextGroup = Array.from(groups.values())
        .filter((group) => group.type === 'size' && group.order > 30 && group.chosen)
        .sort((a, b) => a.order - b.order)[0];

      if (nextGroup?.chosen?.li) list.insertBefore(thirtyGroup.chosen.li, nextGroup.chosen.li);
    }

    const bottleGroup = groups.get('original-bottle');
    if (bottleGroup?.members?.length) {
      const master = chooseBottleMaster(bottleGroup.members);
      const anyChecked = bottleGroup.members.some(({ input }) => input.checked);
      const anyEnabled = bottleGroup.members.some(({ input }) => !input.disabled);

      bottleGroup.members.forEach(({ li, input }) => {
        li.hidden = true;
        li.setAttribute(BOTTLE_MEMBER_ATTR, 'true');
        input.setAttribute(BOTTLE_MEMBER_ATTR, 'true');
      });

      if (master) {
        master.li.hidden = false;
        master.li.setAttribute(BOTTLE_MASTER_ATTR, 'true');
        master.input.setAttribute(BOTTLE_MASTER_ATTR, 'true');
        master.input.checked = anyChecked;
        master.input.disabled = !anyChecked && !anyEnabled;
        setLabel(master.li, 'Original Bottle', null);

        if (master.li !== list.lastElementChild) list.appendChild(master.li);
      }
    }
  };

  const hideNoise = () => {
    const sizeDetails = new Set(getSizeDetails());
    document.querySelectorAll('details[data-filter]').forEach((details) => {
      if (sizeDetails.has(details)) return;
      details.querySelectorAll('.details__content li').forEach((li) => {
        const label = normalise(li.querySelector('label')?.textContent || '');
        if (label === 'flash sale' || label === 'sale2025' || label === 'original bottle') li.hidden = true;
      });
    });
  };

  const rebuildAll = () => {
    rebuildQueued = false;
    getSizeDetails().forEach(rebuildDetails);
    hideNoise();
  };

  const scheduleRebuild = () => {
    if (rebuildQueued) return;
    rebuildQueued = true;
    requestAnimationFrame(() => requestAnimationFrame(rebuildAll));
  };

  document.addEventListener('change', (event) => {
    const thirtyMaster = event.target.closest?.(`input[${THIRTY_MASTER_ATTR}="true"]`);
    if (thirtyMaster) {
      const details = thirtyMaster.closest('details[data-filter]');
      if (details) {
        details.querySelectorAll(`input[${THIRTY_MEMBER_ATTR}="true"][name]`).forEach((input) => {
          if (input === thirtyMaster) return;
          input.checked = thirtyMaster.checked && !input.disabled;
        });
      }
      return;
    }

    const master = event.target.closest?.(`input[${BOTTLE_MASTER_ATTR}="true"]`);
    if (!master) return;

    const details = master.closest('details[data-filter]');
    if (!details) return;

    details.querySelectorAll(`input[${BOTTLE_MEMBER_ATTR}="true"][name]`).forEach((input) => {
      if (input === master) return;
      input.checked = master.checked && !input.disabled;
    });
  }, true);

  document.addEventListener('collection:reloaded', scheduleRebuild);
  document.addEventListener('shopify:section:load', scheduleRebuild);

  const addMobileLayoutGuard = () => {
    if (document.getElementById('BloomMobileFacetLayout')) return;
    const style = document.createElement('style');
    style.id = 'BloomMobileFacetLayout';
    style.textContent = `
      @media screen and (max-width: 767px) {
        #FacetDrawerSticky .drawer__inner { width: 100vw; max-width: 100vw; }
        #FacetDrawerSticky .drawer__content { min-height: 0; }
        #FacetDrawerSticky .drawer__scrollable {
          min-height: 0;
          overflow-y: auto;
          overscroll-behavior: contain;
          padding-bottom: calc(88px + env(safe-area-inset-bottom, 0px));
        }
        #FacetDrawerSticky .drawer__sticky {
          background: rgb(var(--color-background));
          padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
        }
      }
    `;
    document.head.appendChild(style);
  };

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      const hasMeaningfulAddedNode = Array.from(record.addedNodes).some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        if (node.matches?.(`[${SYNTHETIC_30_ATTR}]`)) return false;
        return true;
      });

      if (hasMeaningfulAddedNode) {
        scheduleRebuild();
        return;
      }
    }
  });

  const start = () => {
    addMobileLayoutGuard();
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    scheduleRebuild();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
